import { fetchWithTimeout, handleError, handleResponseError } from "./handlers";

export const fetchControlData = (token, month, year) => {
    return async (dispatch) => {
        const [controlsRes, eventsRes, membersRes] = await Promise.all([
            fetchWithTimeout(`/controls/${month}/${year}`, { headers: { 'Authorization': 'Bearer ' + token } }),
            fetchWithTimeout(`/events/${month}/${year}`, { headers: { 'Authorization': 'Bearer ' + token } }),
            fetchWithTimeout(`/control/members`, { headers: { 'Authorization': 'Bearer ' + token } })
        ]);

        if (controlsRes.ok && eventsRes.ok && membersRes.ok) {
            const controlsData = await controlsRes.json();
            const eventsData = await eventsRes.json();
            const membersData = await membersRes.json();

            if (controlsData.response && eventsData.response && membersData.response) {
                dispatch({ type: 'FETCH', controls: controlsData.data, events: eventsData.data, members: membersData.data });
            } else {
                const err = (!controlsData.response && controlsData.data) || (!eventsData.response && eventsData.data) || (!membersData.response && membersData.data);
                dispatch(handleError(err));
            }
        } else {
            const failedRes = !controlsRes.ok ? controlsRes : (!eventsRes.ok ? eventsRes : membersRes);
            dispatch(handleResponseError(failedRes));
        }
    }
}

export const saveControl = (token, data, notify) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout('/control', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(data)
        }, notify);

        if (res.ok) {
            const { response, data: resData } = await res.json();
            if (response) dispatch({ type: 'SAVE', control: resData });
            else dispatch(handleError(resData));
        } else {
            dispatch(handleResponseError(res));
        }
    }
}

export const fetchControlDetail = (token, uuid) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout(`/control/${uuid}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        });

        if (res.ok) {
            const { response, data } = await res.json();
            if (response) dispatch({ type: 'FETCH', control: data });
            else dispatch(handleError(data));
        } else {
            dispatch(handleResponseError(res));
        }
    }
}
